import { formatCurrency } from 'utils/formatCurrency';
import { IApiUpdateTicketBody } from '../services/types/ticket';
import { IUICashierFormValues, IUISelectItem } from './cashier.interface';
import { DISCOUNT_FORM_TYPE } from './features/Discount/DiscountModalV2/SalonDiscountTab';

export const HEIGHT_HEADER = 96;

export const absoluteDecimal = (amount: number | null | undefined) => {
  return parseFloat(formatCurrency(amount || 0).replace('$', '') || '');
};

export const calcDiscountForItem = (o: IUISelectItem) => {
  if (o.requiredMember && !o.customerId) return 0;
  if (!o.discountSetting?.discountValue) return 0;
  const amount = (o.price || 0) * (o.quantity || 0);
  if (o.discountSetting?.discountType === DISCOUNT_FORM_TYPE.PERCENT) {
    return absoluteDecimal(amount * (o.discountSetting.discountValue / 100));
  }
  const discountAmount = o.discountSetting.discountValue || 0;
  return discountAmount > amount ? amount : discountAmount;
};

export const mappingSavePayload = (
  values: IUICashierFormValues
): IApiUpdateTicketBody => {
  const body: IApiUpdateTicketBody = {
    billId: values.billId,
    customerId: values.customerId || '',
    staffId: values.staffId,
    couponId: '',
    subTotal: values.subTotal || 0,
    saleTax: values.saleTax || 0,
    useTax: values.useTax || 0,
    total: values.total || 0,
    discount: values.discount || 0,
    items: values.items.map((o) => ({
      discount: calcDiscountForItem(o),
      itemId: o.itemId,
      itemName: o.itemName,
      itemType: o.itemType,
      price: o.price,
      quantity: o.quantity,
      expiredDate: o.expiredDate,
      activeTax: o.activeTax,
      requiredMember: o.requiredMember,
      promotionId: o.promotionId,
    })),
  };
  return body;
};

export const generateKeyInitialValue = (
  values: IUICashierFormValues
): string => {
  return JSON.stringify(values.items) + values.customerId + values.staffId;
};
